export default
    {
        path:'/consultation',
        name:'状态咨询',
        redirect:'/consultation/main',
        component:()=>import('../views/consultation/index'),
        children:[
            {
                path:'/consultation/main',
                name:'状态咨询主页',
                component:()=>import('../views/consultation/main'),
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path:'/consultation/recordDetail',
                name:'状态咨询咨询记录',
                component:()=>import('../views/consultation/consultationRecord/recordDetail.vue'),
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path:'/selfAssessment/consultation/diagnosis/evaluation_entry',
                name:'诊断测评入口',
                component:()=>import('../views/consultation/diagnosis/evaluation/evaluation_entry.vue'),
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path:'/selfAssessment/consultation/diagnosis/evaluation_question',
                name:'诊断测评测试题',
                component:()=>import('../views/consultation/diagnosis/evaluation/evaluation_main.vue'),
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path:'/selfAssessment/consultation/diagnosis/evaluation_question7',
                name:'诊断测评测试题第7题注意力训练',
                component:()=>import('../views/consultation/diagnosis/evaluation/evaluation_question7.vue'),
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path:'/consultation/sweet',
                name:'舒尔特方格',
                component:()=>import('../views/consultation/themeTraining/sweet.vue'),
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path:'/consultation/sweetDetail',
                name:'舒尔特方格测试内容',
                component:()=>import('../views/consultation/themeTraining/sweetDetail.vue'),
                meta:{requireAuth:true,roles:['student']},
            }
        ]
    }